import { AuthenticationType, IAzureMapOptions } from 'react-azure-maps';
import { getMapsAuth } from 'api/maps/controller';

export interface IMapOptions {
	clientId: string;
	latitude: number;
	longitude: number;
}
const getMapOptions = (options: IMapOptions): IAzureMapOptions => ({
	authOptions: {
		authType: AuthenticationType.anonymous,
		clientId: options.clientId,
		getToken: (resolve, reject) => {
			getMapsAuth()
				.then(auth => resolve(auth.token))
				.catch(reject);
		}
	},
	autoResize: true,
	showFeedbackLink: false,
	showTileBoundaries: false,
	showLogo: false,
	showBuildingModels: true,
	style: 'road',
	center: [options.longitude, options.latitude],
	zoom: 12
});

export const mapService = {
	getMapOptions
};
